import Clasifications from './Clasifications';
export default Clasifications;